/**
 * Base Cali — collection page behaviour (vanilla, no deps).
 *  • Auto-submit the filter form (GET) on change — Shopify applies the facets.
 *    Price number inputs are debounced.
 *  • Sort <select> is associated to the form via the `form` attribute; submit on change.
 *  • Mobile filter drawer open/close.
 */
(function () {
  function submitForm(form) {
    if (!form) return;
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  }

  function initCollection(section) {
    if (section.dataset.catReady) return;
    section.dataset.catReady = '1';

    const form = section.querySelector('[data-collection-filters]');

    if (form) {
      let timer;
      form.addEventListener('change', (event) => {
        const isNumber = event.target && event.target.type === 'number';
        window.clearTimeout(timer);
        timer = window.setTimeout(() => submitForm(form), isNumber ? 700 : 0);
      });
    }

    // Sort select lives in the toolbar but belongs to the form via form="…".
    const sort = section.querySelector('[data-cat-sort]');
    if (sort && form) {
      sort.addEventListener('change', () => submitForm(form));
    }

    // Mobile drawer
    const panel = section.querySelector('[data-filter-panel]');
    const openBtn = section.querySelector('[data-filter-open]');
    const closeEls = section.querySelectorAll('[data-filter-close]');

    function open() {
      if (panel) panel.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      if (panel) panel.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (openBtn) openBtn.addEventListener('click', open);
    closeEls.forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-base-cat]').forEach(initCollection);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', () => boot());

  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
